
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Arc extends Vue {
  @Prop() private color!: string;
  @Prop() private rotation!: number;

  getRotation(){
    return `transform: rotate(${this.rotation*30}deg)`
  }
}

